import React from 'react';
import tw from 'twin.macro';
import { Outlet } from 'react-router-dom';
import Header from 'components/headers/light.js';
import Footer from 'components/footers/FiveColumnWithInputForm.js';

const PageContainer = tw.div`min-h-screen flex flex-col overflow-x-hidden`;
const MainContent = tw.main`flex-1 pt-32`;

const PublicLayout = () => {
	return (
		<PageContainer>
			<Header />
			<MainContent>
				<Outlet />
			</MainContent>
			<Footer />
		</PageContainer>
	);
};

export default PublicLayout;
